import { ListItem, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Link } from "react-router-dom"

export const StyledLink = styled(Link)(({ route }: { route?: any }) => ({
  textDecoration: "none",
  cursor: route ? "pointer" : "default"
}))

export const StyledListItem = styled(ListItem)({
  padding: "0",
  alignItems: "start"
})

export const StyledGreyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500]
}))

export const StyledBlackText = styled(Typography)(({ theme }) => ({
  color: (theme.palette as any).foreground?.default,
  fontWeight: 600,
  fontSize: "28px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "24px"
  }
}))
